import { render, staticRenderFns } from "./color-indicator-wrapper.vue?vue&type=template&id=01f6a51c&scoped=true&"
import script from "./color-indicator-wrapper.vue?vue&type=script&lang=js&"
export * from "./color-indicator-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./color-indicator-wrapper.vue?vue&type=style&index=0&id=01f6a51c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f6a51c",
  null
  
)

export default component.exports